import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Password } from "primereact/password";
import dayjs from "dayjs";

const overlay = typeof document !== "undefined" ? document.body : null;

export function SipInput({ className = "", ...props }) {
  return <InputText className={`sip-input w-full min-w-0 ${className}`} {...props} />;
}

export function SipSearch({ className = "", ...props }) {
  return (
    <span className={`sip-search ${className}`}>
      <i className="pi pi-search" aria-hidden="true" />
      <InputText className="sip-input w-full min-w-0" {...props} />
    </span>
  );
}

export function SipTextarea({ className = "", ...props }) {
  return (
    <InputTextarea className={`sip-textarea w-full min-w-0 ${className}`} autoResize {...props} />
  );
}

export function SipPassword({ className = "", ...props }) {
  return (
    <Password
      className={`sip-password w-full min-w-0 ${className}`}
      inputClassName="sip-input w-full min-w-0"
      toggleMask
      feedback={false}
      {...props}
    />
  );
}

export function SipCheck({ name, onChange, inputId, ...props }) {
  return (
    <Checkbox
      inputId={inputId || name}
      {...props}
      onChange={(event) =>
        onChange?.({
          target: {
            name,
            type: "checkbox",
            checked: !!event.checked,
            value: event.checked,
          },
        })
      }
    />
  );
}

export function SipDropdown({
  value,
  onChange,
  options = [],
  placeholder = "Pilih...",
  disabled = false,
  className = "",
  filter,
  name,
}) {
  const showFilter = filter ?? options.length > 8;
  return (
    <Dropdown
      name={name}
      value={value === "" || value == null ? null : value}
      options={options}
      optionLabel="label"
      optionValue="value"
      placeholder={placeholder}
      disabled={disabled}
      filter={showFilter}
      resetFilterOnHide
      onChange={(event) =>
        onChange?.({ target: { name, value: event.value ?? "" } })
      }
      className={`sip-dropdown w-full min-w-0 ${className}`}
      panelClassName="sip-dropdown-panel"
      appendTo={overlay}
    />
  );
}

export function SipCalendar({
  value,
  onChange,
  name,
  placeholder = "Pilih tanggal",
  disabled = false,
  className = "",
}) {
  const dateValue = value ? dayjs(value).toDate() : null;
  return (
    <Calendar
      value={Number.isNaN(dateValue?.getTime?.()) ? null : dateValue}
      onChange={(event) =>
        onChange?.({
          target: {
            name,
            value: event.value ? dayjs(event.value).format("YYYY-MM-DD") : "",
          },
        })
      }
      dateFormat="dd/mm/yy"
      showIcon
      showButtonBar
      placeholder={placeholder}
      disabled={disabled}
      className={`sip-calendar w-full min-w-0 ${className}`}
      inputClassName="sip-input"
      panelClassName="sip-calendar-panel"
      appendTo={overlay}
    />
  );
}

export function withAll(items, allLabel) {
  return [
    { label: allLabel, value: "" },
    ...(items || []).map((item) => ({
      label: String(item),
      value: String(item),
    })),
  ];
}
